<template>
    <div>
        <b-modal @hide="close" size="lg" ref="add-flag-modal" id="add-flag-modal">
            <template v-slot:modal-header>
                <span class="h3">Order #: {{ order.id }}</span>

                <b-button :href="'/kit/view/'+order.id" v-if="$route.name != 'kit-view-index'"
                          variant="success">View Kit <i class="fa-solid fa-arrow-circle-right"
                ></i>
                </b-button>
            </template>
            <template>
                <ValidationObserver v-slot="{ invalid }" ref="flagform">
                <!-- flag type -->

                <b-form-group
                    label="Flag:"
                    label-for="flag-type-select">
                    <select v-if="_flagTypes.length > 0"  v-model="flag.flag_type_id">
                        <option value="null" disabled selected>Select Flag Type</option>
                        <optgroup v-for="(value, name) in _flagsByCategory" :label="name">
                            <option v-for="(flag, index) in value" :value="flag.id" v-b-tooltip.hover
                                    :title="flag.description" :key="index">{{flag.name}}</option>
                        </optgroup>
                    </select>
                    <i v-else class="fa-regular fa-spinner fa-spin"></i>
                </b-form-group>

                <!-- notes -->
                <b-form-group
                    label="Notes:"
                    label-for="flag-notes">
                    <b-form-textarea
                        placeholder="Add note"
                        v-model.lazy="flag.note"
                        id="replies"
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                </b-form-group>

                <!-- requester -->
                <b-form-group
                    label="Requester:"
                    label-for="requester">
                    <b-form-input id="requester" :disabled="true" v-model="$store.getters.getProfile.name"></b-form-input>
                </b-form-group>

                <!-- recipient -->
                
                    <b-form-group label="Recipients:" label-for="tags-with-dropdown"
                    :state="flag.users.length > 0" invalid-feedback="The Recipients field is required.">
                        <b-form-tags id="tags-with-dropdown" no-outer-focus class="mb-2" :state="flag.users.length > 0">
                            <template v-slot="{ tags, disabled }">
                                <ul v-if="flag.users.length > 0" class="list-inline d-inline-block mb-2">
                                    <li v-for="user in flag.users" class="list-inline-item"
                                        @click="removeTag(user)">
                                        <b-form-tag
                                                :title="user.email"
                                                :disabled="disabled"
                                                variant="info"
                                        >{{ user.name }}</b-form-tag>
                                    </li>
                                </ul>

                                <b-dropdown size="sm" variant="outline-secondary" block menu-class="w-100" :active="true">
                                    <b-dropdown-form @submit.stop.prevent="() => {}">
                                        <b-form-group
                                                label="Search tags"
                                                label-for="tag-search-input"
                                                label-cols-md="auto"
                                                class="mb-0"
                                                label-size="sm">
                                            <b-form-input
                                                    v-model="search"
                                                    id="tag-search-input"
                                                    type="search"
                                                    size="sm"
                                                    autocomplete="off"
                                            ></b-form-input>
                                        </b-form-group>
                                    </b-dropdown-form>
                                    <b-dropdown-divider></b-dropdown-divider>
                                    <b-row class="no-gutters">
                                        <b-col cols="6" class="set-height">
                                            <b-dropdown-item-button
                                                    v-for="option in _displayUsers"
                                                    @click.native.capture.stop="addUser(option)">
                                                {{ option.name }}
                                            </b-dropdown-item-button>
                                            <b-dropdown-text v-if="loading">
                                                Loading....
                                            </b-dropdown-text>
                                        </b-col>
                                        <b-col cols="6" class="set-height">
                                            <b-dropdown-item-button
                                                    v-for="option in _displayGroup"
                                                    @click.native.capture.stop="addGroup(option)">
                                                {{ option.name }}
                                            </b-dropdown-item-button>
                                            <b-dropdown-text v-if="loading">
                                                Loading....
                                            </b-dropdown-text>
                                        </b-col>
                                    </b-row>
                                </b-dropdown>
                            </template>
                        </b-form-tags>
                    </b-form-group>
                    

                <!-- stop workflow/priority -->
                <div class="d-flex">
                    <b-form-checkbox class="mr-5" name="check-button" switch v-model="flag.stop_workflow">
                        <strong>Stop Workflow</strong>
                    </b-form-checkbox>

                    <b-form-checkbox name="check-button" switch v-model="flag.priority">
                        <strong>Priority</strong>
                    </b-form-checkbox>
                </div>

                <!-- date/time picker -->
                <div class="my-3">

                    <!--<label class="d-block mb-0" for="date-picker">Follow Up Date/Time:</label>
                    <datetime id="date-picker" v-model="flag.follow_up"
                              class="d-inline-block"
                              value-zone="America/New_York"
                              :use12-hour="true"
                              :minute-step="15"
                              type="datetime">
                    </datetime> -->
                    <ValidationProvider rules="required" name="Follow Up Date/Time" immediate v-slot="{ valid, errors }">
                        <b-form-group label="Follow Up Date/Time:" label-class="font-weight-bold" style="max-height:60px;"
                        :state="valid" :invalid-feedback="errors[0]">
                            
                            <vc-date-picker mode="dateTime" v-model="flag.follow_up" :minute-increment="5" :popover="datePickerProps"
                            :timezone="'America/New_York'" :attributes="todaysDot" :min-date="new Date()" :disabled-dates='{ weekdays: [1, 7] }'>
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div v-on:click="" v-on="inputEvents" style="width:200px">
                                        <div class="text-center form-control d-inline" style="width:170px!important; max-height:30px">
                                            {{ flag.follow_up | datetime }}{{ flag.follow_up ? '': 'mm-dd-yyyy mm:ss' }}

                                        </div>
                                        <i v-on:click="clearDate()" style="top: 5px; font-size:31px" class="pointer position-relative fa-solid fa-window-close text-danger"></i>
                                    </div>
                                </template>
                            </vc-date-picker>
                        </b-form-group>
                    </ValidationProvider>
                </div>

                </ValidationObserver>
            </template>


            <template v-slot:modal-footer>
                <div class="w-100">
                    <b-button @click="save" variant="primary" class="float-right" :disabled="isSaving || !_canSave"><i class="fa-regular fa-spinner fa-spin mr-2" v-if="isSaving"></i>Save Flag</b-button>
                    <b-button @click="close" class="float-right mx-2">Cancel</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {Datetime} from 'vue-datetime';
import _ from 'lodash';
import DateRangePicker from 'vue2-daterange-picker'
import {
    SYNC_USER,
} from '../store/actions';

export default {
    name: 'AddFlagModal',
    components: {Datetime,DateRangePicker},
    props: ['FlagEditIsOpen',],
    data() {
        return {
            //FIXME make as cache
            allFlagTypes: [],
            allUsers: [],
            allRoles: [],
            loading: true,
            flagOptions: ['Follow Up', 'Loss Prevention', 'Quote', 'Repair Request', 'Returns Expedite',
                'Suspicious Activity', 'High-Value Pending Offer', 'Enhanced Verification', 'Diamond', 'Brand Packaging', 'Out For Estimate', 'PTA', 'PTA + Enhanced Verification', 'Payment - Return ACH'],
            date: null,
            order: null,
            flag: {
            },
            isSaving: false,
            search: '',
            datePickerProps: {
                placement: 'right',
            },
            todaysDot: [
                {
                    key: 'today',
                    dot: true,
                    content: 'blue',
                    dates: new Date(),
                }
            ]
        };
    },
    methods: {
        open() {
            this.order = this.$store.getters.activeOrder || {id: this.$store.getters.addingFlag};
            this.flag = {
                flag_type_id: null,
                follow_up: null,
                note: null,
                stop_workflow: false,
                priority: false,
                roles: [],
                users: [],
            };
            if(this.loading){
                //this.$http.get('/flag-types?include=usersCanAssign,rolesCanAssign&filter[is_manually_selectable]=1').then((e)=>{
                let count = 0;

                this.$store.dispatch(SYNC_USER, (profile) => {
                    this.$http.get('/flag-types?include=rolesCanCreate,usersCanCreate,rolesCanAuto,usersCanAuto&filterByUser=1&filter[is_manually_selectable]=1').then((e)=>{
                        this.allFlagTypes = [];
                        _.forEach(e.data.data, (z) => {
                            for(let i = 0; i < z.usersCanCreate.data.length; i++) {
                                if(z.usersCanCreate.data[i].id == profile.id) {
                                    this.allFlagTypes.push(z);
                                    return;
                                }
                            }
                            if(false && this.$store.getters.hasRole('Super Admin')) {
                                this.allFlagTypes.push(z);
                                return;
                            } else {
                                for (let i = 0; i < z.rolesCanCreate.data.length; i++) {
                                    if (
                                        this.$store.getters.hasRole(z.rolesCanCreate.data[i].name)
                                        || z.rolesCanCreate.data[i].name == "Read Only"
                                    ) {
                                        this.allFlagTypes.push(z);
                                        return;
                                    }
                                }
                            }
                        });
                        count++;
                        if(count == 3){
                            this.loading = false;
                            this.checkFlagType();
                        }
                    });
                    this.$http.get('/users').then((e)=>{
                        this.allUsers = e.data.data;
                        count++;
                        if(count == 3){
                            this.loading = false;
                            this.checkFlagType();
                        }
                    });
                    this.$http.get('/roles').then((e)=>{
                        this.allRoles = e.data.data;
                        count++;
                        if(count == 3){
                            this.loading = false;
                            this.checkFlagType();
                        }
                    });
                });
            }
            this.$refs['add-flag-modal'].show();
        },
        save() {
            if(!this.flag.flag_type_id){
                this.$parent.$bvModal.msgBoxOk('Flag type is required', {
                    title: 'Invalid Input',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    headerClass: 'p-2 border-bottom-0 text-center d-block',
                    footerClass: 'p-2 border-top-0',
                });
                return;
            }
            this.isSaving = true;
            let payload = {
                flag_type_id: this.flag.flag_type_id,
                follow_up: this.flag.follow_up ? this.flag.follow_up: null,
                note: this.flag.note,
                stop_workflow: this.flag.stop_workflow,
                priority: this.flag.priority,
                users: _.map(this.flag.users, function(e){return e.id;}),

            };
            let flagType = _.filter(this.allFlagTypes, (e) => {return e.id == this.flag.flag_type_id})[0];
            let primaryEndpoint = null;
            let primaryID = null;
            if (flagType.flaggable_type == 'GoldExchange\\Models\\Order') {
                primaryEndpoint = 'orders';
                primaryID = this.order.id;
            } else if (flagType.flaggable_type == 'GoldExchange\\Models\\Customer') {
                primaryEndpoint = 'customers';
                primaryID = this.order.customer.id;
            }
            this.$http.post('/' + primaryEndpoint + '/' + primaryID + '/flags', payload)
            .then(response => {
                this.isSaving = false;
                console.log(response);
                this.$store.commit('commitFlag',response.data.data); //for the instant feel.
                this.close();
            }).catch((e)=>{
                this.isSaving = false;
            });
        },
        clear() {
            this.close();
        },
        close() {
            this.$refs['add-flag-modal'].hide();
            this.$emit('closeFlagAdd');
            this.$store.commit('setAddFlag', false);
        },
        clearDate() {
            this.flag.follow_up = null;
            this.$forceUpdate();
            this.$refs.dt_picker.$forceUpdate();
        },
        removeTag(user){
            let i = this.flag.users.indexOf(user);
            if(i != -1) {
                this.flag.users.splice(i,1);
            }
        },
        addUser(user){
            this.flag.users.push(user);
        },
        addGroup(option){
            _.forEach(_.filter(this.allUsers,(e)=>{
                return -1 == _.findIndex(this.flag.users,(z)=>{return z.id == e.id;})
                &&
                -1 != _.findIndex(option.users.data,(z)=>{return z.id == e.id;});
            }), (e)=> {
                this.flag.users.push(e);
            });
        },
        checkFlagType() {
            if (this.flag.flag_type_id) {
                _.forEach(_.filter(this.allFlagTypes, (e) => {
                    return e.id == this.flag.flag_type_id;
                }), (e) => {
                    this.flag.users = [];
                    let allUsersAssigned = e.usersCanAuto.data;
                    let allRolesAssigned  = e.rolesCanAuto.data;

                    _.forEach(_.filter(allUsersAssigned, (user) => {return user.auto_assign == '1';}),(user) => {
                        this.addUser(user)
                    });
                    _.forEach(allRolesAssigned, (role) => {
                        if(role.auto_assign == '1') {
                            this.addGroup(role);
                        }
                    });
                    let decodedConfig = JSON.parse(e.config);
                    if (decodedConfig.stop_workflow && decodedConfig.stop_workflow == 1) {
                        this.flag.stop_workflow = true;
                    }
                    _.forEach(_.filter(this.allFlagTypes, (e)=> {return e.id == this.flag.flag_type_id}), (e)=>{
                        _.forEach(e.roles,(z)=>{
                            this.addGroup(z);
                        });
                        _.forEach(e.users,(z)=>{
                            if(-1 == _.findIndex(this.flag.users, (s) =>{return s.id == z.id})){
                                let index = _.findIndex(this.allUsers, (s) =>{return s.id == z.id});
                                if(index != -1){
                                    this.addUser(this.allUsers[index]);
                                }
                            }
                        });
                        let decodedConfig = JSON.parse(e.config);
                        if (decodedConfig.stop_workflow && decodedConfig.stop_workflow == 1) {
                            this.flag.stop_workflow = true;
                        }
                    });
                });
            }
        }
    },
    computed: {
        _flagsByCategory() {
            return _.groupBy(this.allFlagTypes, 'section');
        },
        _flagTypes() {
            return _.map(this.allFlagTypes, (flag) =>{
                return {
                    value: flag.id,
                    text: flag.name,
                }
            });
        },
        selectedFlag () {
            if (this.$store.getters.isFlagLoaded) {
                return this.$store.getters.activeFlag;
            } else {
                return null;
            }
        },
        _isFlagAdding () {
            return this.$store.getters.addingFlag;
        },
        _userTags(){
            return _.map(this.flag.users, function(user){ return user.name });
        },
        _roleTags(){
            return _.map(this.flag.roles, function(user){ return user.name });
        },
        _allTags(){
            return _.union(this._roleTags, this._userTags);
        },
        _displayUsers: function(){
            return _.filter(this.allUsers, (e)=>{return  -1 == _.findIndex(this.flag.users,(z)=>{return e.id == z.id}) && e.name.toLowerCase().includes(this.search.toLowerCase());});
        },
        _displayGroup: function(){
            return _.filter(this.allRoles, (e)=>{return e.name.toLowerCase().includes(this.search.toLowerCase());});
        },
        _canSave() {
            return this.flag.users.length > 0 && this.$refs.flagform.flags.valid;
        }
    },
    watch: {
        _isFlagAdding: function (val) {
            console.log('flag_issue',val);
            (!val) ? this.close() : this.open();

        },
        'flag.flag_type_id': function(val){
            this.checkFlagType();
        },
    }
};
</script>
<style>
    /* fixes HTML layout for text */
    #add-flag-modal .reportrange-text{
        height: 30px !important;
        width:170px !important;
    }
    /*removes thumb nail */
    #add-flag-modal .daterangepicker::before{
        position:relative !important;
        top:0;
        border: 0;
        content: none;
    }
    #add-flag-modal .daterangepicker:after {
        top:0;
    }
    /* positions to the right*/
    #add-flag-modal .dropdown-menu{
        top: -100px !important;
        left: 203px !important;
        -webkit-transition: none !important;
        -moz-transition: none !important;
        -o-transition: none !important;
        transition: none !important;
    }
    #add-flag-modal .set-height {
        padding: 0;
        margin:0;
        height: 200px !important;
        overflow: scroll !important;
    }
    #add-flag-modal .w-100 {
        /*fixes other modal*/
        top: 0px !important;
        left: 0px !important;
    }
</style>
